import router from '@/router'
import { AppSidebar, AppHeader } from '@/components'

export const routes = [
  {
    path: '/credit-safe-report',
    name: 'credit-safe-report',
    meta: {
      sitemap: {
        title: 'Credit score',
        description: 'Credit report and analysis',
        conditions: {
          all: [{ fact: 'additionalProducts', path: '$.enableCreditsafeReportPage', operator: 'equal', value: true }]
        }
      },
      permissions: {
        roles: ['user'],
        redirectTo: {
          name: 'login'
        }
      }
    },
    components: {
      default: () => import('./creditSafe.vue'),
      sidebar: AppSidebar,
      header: AppHeader
    }
  }
]

export default () => {
  routes.forEach(route => router.addRoute(route))
}
